import React, {  useMemo, useState } from "react";
import { Box, Text, Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Tag } from "@chakra-ui/react";
import {  useSelector } from "react-redux";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import ExpenseTable from "../vendorDetail/expenseTable";
import CustomDropdown from "../vendorDetail/vendorLedger/customDateRenge";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { Form } from "react-bootstrap";
import { dateFormatWithTime } from "jsFunctions/dateTime.js";
import { financialYearOptions } from "jsFunctions/dateTime";
import useTransactionData from "hooks/useTransactionData";


const statementColumns = [
  {
    Header: "No",
    accessor: "no",
  },
  {
    Header: "PoNo",
    accessor: "poNo",
  },
  {
    Header: "Payment Id",
    accessor: "paymentId",
  },
  {
    Header: "Vendor",
    accessor: "vendor",
  },
  {
    Header: "Request Id",
    accessor: "requestId",
  },
  {
    Header: "UTR No",
    accessor: "utrNo",
  },
  {
    Header: "Unique Id",
    accessor: "uniqueId",
  },
  {
    Header: "Date",
    accessor: "date",
  },
  {
    Header: "Amount",
    accessor: "amount",
  },
  {
    Header: "Status",
    accessor: "status",
  },
 
]

const TransactionDetails = () => {
  const [dateRange, setDateRange] = useState({ startDate: '', endDate: '' });
  const [type,setType] = useState("")
  const [selectedPeriod, setSelectedPeriod] = useState('lastOneWeek');
  const moduleType = useSelector((state) => state.moduleType);

  const moduleOpt = useMemo(()=>{
    if(moduleType && moduleType?.length > 0){
      const opt = moduleType.map((item)=>{
        return {
          label:item.name,
          value: item._id,
          module:item.name
        }
      })
      return opt;
    }
    return []
  },[moduleType])

  
  const { loading, allTransactions, dateRangeText } = useTransactionData(selectedPeriod, dateRange, type);

  const transactionData = useMemo(()=>{
    if(allTransactions && allTransactions?.length > 0){
      const tableData = allTransactions.map((data, index) => {
        return {
          _id: data._id,
          no: index + 1,
          poNo: <span>{data?.poNo}</span>,
          paymentId: <span>{data?.pmId}</span>,
          vendor: <span>{data?.vId?.name}</span>,
          amount: (
            <span className={`${data?.sts === 'SUCCESS' ? 'blue' :'black'}`}>
              ₹ {data?.amt}
            </span>
          ),
          requestId: <span> {data?.reqId}</span>,
          utrNo: (<span>{data?.utr}</span>),
          uniqueId: <span className="f-600">{data?.unqId}</span>,
          date: <span>{dateFormatWithTime(data?.crAt)}</span>,
          status: (<Tag size="sm" bg={`${data?.sts === 'SUCCESS' ? 'green' :'red'}`} variant="solid">{data?.sts}</Tag>)
        };
      });
      const totalAmount = allTransactions.reduce((sum, data) => {
        return sum + (data?.amt || 0); 
      }, 0);
      return { tableData, totalAmount };    
    }
    return { tableData:[], totalAmount:0 };
  },[allTransactions])
  


  if (loading) {
    return <SpinnerLoader />;
  }


  return (
    <Box display="flex" className="mx-0 expense_details account-statement">
      <Box className="expense_details_main account-statement-list">
        <Box display="flex" justifyContent="space-between" mt={5}>

            <Box display="flex">

          <Box className="ledger-year-select">
            <CustomDropdown
              years={financialYearOptions}
              selectedYear={selectedPeriod}
              setSelectedYear={setSelectedPeriod}
              handleApply={(date) => setDateRange(date)}
              dateRenge={dateRange}
            />
          </Box>
          <Form.Select
          size="sm"
          className="transaction-select"
          onChange={(e) => setType(e.target.value)}
          value={type}
        >
          <option>All</option>
          {moduleOpt.map((opt)=>{
            return <option value={opt.value}>{opt.label}</option>
          })}        
        </Form.Select>
            </Box>

          <Text fontWeight="600" fontSize="14px" mt={2}>
            Transaction Details ( {dateRangeText} )
          </Text>
          <div></div>
          <div></div>
        </Box>

        <Box className="acordian-box ">
          <Accordion defaultIndex={[0]} allowMultiple>
            <AccordionItem className="acordian-item" borderTop="none">
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    <Text fontWeight="600">Transactions </Text>
                  </Box>
                  <Box flex="1" className="mx-3" display="flex"  justifyContent="flex-end" flexDirection="row">
                  <Text className="mt-1" fontWeight="400">Total Amount : <span className="creditAmount blue">₹ {formatAmountIndianRupees(transactionData?.totalAmount)}</span> </Text>
            </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel className="acordian-panal  px-2 p-0 m-0">
                {transactionData?.tableData && transactionData?.tableData?.length > 0 ? (
                  <ExpenseTable
                    columnsData={statementColumns}
                    tableData={transactionData?.tableData}
                  />
                ) : (
                  <Text className="py-3" fontWeight="600" textAlign="center">
                    There are no transaction
                  </Text>
                )}
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </Box>
      </Box>
    </Box>
  );
};

export default TransactionDetails;
